import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import styles from '../ManagementPages.module.css';
import ManagementDropdownCard from '../../components/ManagementDropdownCard';
import { setDevice, setModality, setSerialNumber } from './UpdatePatchSlice';
import { showAlert } from '../../components/PerinHealthAlertSlice';
import useAxios from '../../services/AxiosConfig';

const UpdatePatch = () => {
    const [errorMessage, setErrorMessage] = useState('');
    const updatePatchState = useSelector((state) => state.updatePatch);
    const patchInformation = updatePatchState.patchInformation;
    const axiosConfig = useSelector((state) => state.axiosConfig);
    const axios = useAxios(axiosConfig.envURL);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const removeDeviceCard = (id) => {
        console.log('remove device');
    }
    const [errors, setErrors] = useState({
        message: "All devices are required to have a valid start time and frequency",
        showing: false,
        modalityMessage: "Please make sure upper limit > lower limit and target value is in between values",
        modalityShowing: false,
        modalityErrors: [],
        deviceIdErrors: [],
        perinModalityErrors: [],
        serialNumberMessage: "Please enter a valid serial number for all devices",
        serialNumberShowing: false
    });

    const handleSetSerialNumber = ({ id, serial, serialId }) => {
        dispatch(setSerialNumber({ id, serial, serialId }))
    };

    const formatProgramData = () => {
        const data = updatePatchState.program
        const formattedGroups = data.enrollment.groups.map((group) => {
            return {
                groupId: group.groupId,
                organizationId: group.organizationId,
                subGroupId: group.subGroupId,
                teamId: group.teamId,
                accountTeamPatientId: group.accountTeamPatientId,
            };
        });

        let newDevices = [];
        updatePatchState.modalities.forEach((mod) => {
            let tempDevice = { ...mod };
            delete tempDevice['templateId'];
            delete tempDevice['macAddress'];
            tempDevice["rules"] = [];
            newDevices.push(tempDevice);
        })


        const returnData = {
            duration: data.duration,
            name: data.name,
            description: data.description,
            groupId: data.groupId,
            patient: {
                id: data.patient.id,
                firstName: data.patient.firstName,
                lastName: data.patient.lastName,
            },
            enrollment: {
                groups: formattedGroups,
                startDate: data.enrollment.startDate,
                endDate: data.enrollment.endDate,
            },
            devices: newDevices,
            contents: [],
            questionnaires: [],
            hubs: [],
            duration: data.duration === "" ? 0 : data.duration
        };
        return returnData;
    };

    const handleUpdateCareProgram = async () => {
        // const updatedProgram = {
        //     ...updatePatchState.program,
        //     devices: updatePatchState.modalities
        // };
        const updatedProgram = formatProgramData();
        console.log("updatePatchState:", updatePatchState);
        console.log("updatedProgram:", updatedProgram);
        const url = `enrollment/${updatePatchState.program.enrollmentId}`;

        try {
            const response = await axios.request({
                method: 'PUT',
                headers: { "Content-Type": "application/json" },
                url: url,
                data: JSON.stringify(updatedProgram),
            });
            if (response) {
                dispatch(showAlert({
                    header: "Success",
                    message: `Enrollment updated successfully`,
                    type: 'success'
                }));
                navigate('/inpatient-portal');
            }
        } catch (error) {
            console.log("error:" + error);
            dispatch(
                showAlert({
                    header: "Error",
                    message: `Error updating enrollment`,
                    type: 'danger'
                })
            );
        }

    };

    return (
        <div className={styles.MainCard}>
            <div className={styles.ContentTitle}>{updatePatchState.updating ? `Update Patch for ${updatePatchState.patientName}` : 'Assign Patch'}</div>
            <div className={styles.HideScrollContainer}>
                <ManagementDropdownCard
                    open={true}
                    cardInfo={{ title: patchInformation.model, id: patchInformation.deviceId, type: "Device", modalities: patchInformation.modalities }}
                    removeHandler={removeDeviceCard}
                    updateHandler={setDevice}
                    dataList={[updatePatchState.device]}
                    setModality={setModality}
                    patientEnrollment={true}
                    errorShowing={errors}
                    modalityList={updatePatchState.modalities}
                    allDevices={[patchInformation]}
                    setSerialNumber={handleSetSerialNumber}
                />
            </div>
            <div className={styles.ButtonsFooterContainerWithError}>
                {errorMessage &&
                    <div className="page-error">
                        <FontAwesomeIcon icon="fa-solid fa-triangle-exclamation" size="sm" style={{ color: "red" }} />
                        {errorMessage}
                    </div>
                }
                <div style={{ display: "flex", columnGap: "10px" }}>
                    <Button variant="secondary" className={styles.CancelButton} onClick={() => navigate('/patient-location')}>
                        Cancel
                    </Button>
                    <Button variant="primary" className={styles.CreateButton}
                        onClick={handleUpdateCareProgram}
                    >
                        {'Update'}
                    </Button>
                </div>
            </div>
        </div>
    );

}

export default UpdatePatch;